import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Descriptions,
  Form,
  Image,
  Layout,
  PageHeader,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Tag,
  Typography,
  message,
} from "antd";
import { EditOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { firestoreConnect, isLoaded } from "react-redux-firebase";

import ImageEditModal from "../common/CoverImageEdit";
import { NavLink } from "react-router-dom";
import React, { useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { editClassCard } from "../../store/actions/onlineClass";
import moment from "moment";
import { useState } from "react";

const { Paragraph, Text, Link } = Typography;
const { Option } = Select;

const SinglePostPage = ({
  classCard,
  classCardId,
  editClassCard,
  loaded,
  class_card_categories,
  error,
}) => {
  const [saving, setSaving] = useState(false);
  // const [imageEditVisible, setImageEditVisible] = useState(false);
  const [categories, setCategories] = useState([]);

  async function editClassCardHandle(cardId, field, value) {
    setSaving(true);
    await editClassCard(cardId, field, value);

    if (error) {
      message.error("Update Failed!");
      setSaving(false);
      return;
    }

    message.success("Class Card Updated!");
    setSaving(false);
  }

  useEffect(() => {
    if (loaded && classCard.categories) {
      setCategories(classCard.categories);
    }
  }, [loaded, classCard.categories]);

  if (classCard != null && loaded) {
    return (
      <Layout>
        <PageHeader
          onBack={() => window.history.back()}
          ghost={false}
          title="Edit class card"
          className="site-page-header"
        ></PageHeader>
        {/* <ImageEditModal
            visible={imageEditVisible}
            onCreate={this.updateImage}
            loading={loading}
            onCancel={this.closeImageEditModal}
          /> */}
        <Row>
          <Col sm={{ span: 24 }} md={{ span: 24 }} justify="center">
            <Card
              title={
                <div className="class-name flex flex-row space-x-4 pr-4">
                  <Text
                    editable={{
                      onChange: (val) =>
                        editClassCardHandle(classCardId, "name", val),
                    }}
                  >
                    {classCard.name}
                  </Text>
                  {/* <Tag color="blue">
                    Booked Students Count:{" "}
                    {classCard.total_students_booked ?? 0}
                  </Tag> */}
                </div>
              }
              style={{ margin: "1rem 1rem 0 1rem" }}
              extra={
                <Button type="primary">
                  <NavLink to={`/cards/preview/${classCardId}/bookings`}>
                    Bookings
                  </NavLink>
                </Button>
              }
            >
              <Descriptions>
                {/* <Descriptions.Item label="Booked Students Count" span={3}>
                  <Paragraph>{classCard.total_students_booked ?? 0}</Paragraph>
                </Descriptions.Item> */}
                <Descriptions.Item label="Card Description" span={3}>
                  <Paragraph
                    editable={{
                      onChange: (val) =>
                        editClassCardHandle(classCardId, "description", val),
                    }}
                  >
                    {classCard.description}
                  </Paragraph>
                </Descriptions.Item>

                <Descriptions.Item label="Type" span={3}>
                  <Select
                    defaultValue={classCard.type}
                    disabled={saving}
                    style={{ width: 120 }}
                    onChange={(val) =>
                      editClassCardHandle(classCardId, "type", val)
                    }
                  >
                    <Select.Option value="FULL">FULL</Select.Option>
                  </Select>
                </Descriptions.Item>

                <Descriptions.Item label="Is Available To Purchase" span={3}>
                  <Select
                    defaultValue={classCard.isAvailableToPurchase}
                    disabled={saving}
                    style={{ width: 120 }}
                    onChange={(val) =>
                      editClassCardHandle(
                        classCardId,
                        "isAvailableToPurchase",
                        val
                      )
                    }
                  >
                    <Select.Option value={true}>Yes</Select.Option>
                    <Select.Option value={false}>No</Select.Option>
                  </Select>
                </Descriptions.Item>
                <Descriptions.Item label="Valid From" span={3}>
                  <Form layout="inline">
                    <Form.Item
                      name="validFrom"
                      initialValue={moment(
                        typeof String() === typeof classCard.validFrom
                          ? classCard.validFrom
                          : classCard.validFrom.toDate()
                      )}
                    >
                      <DatePicker
                        disabled={saving}
                        allowClear={false}
                        value={moment(
                          typeof String() === typeof classCard.validFrom
                            ? classCard.validFrom
                            : classCard.validFrom.toDate()
                        )}
                        onChange={(val) =>
                          editClassCardHandle(
                            classCardId,
                            "validFrom",
                            val.format("YYYY MM DD")
                          )
                        }
                      />
                    </Form.Item>
                  </Form>
                </Descriptions.Item>
                <Descriptions.Item label="Valid till" span={3}>
                  <Form layout="inline">
                    <Form.Item
                      name="validTill"
                      initialValue={moment(
                        typeof String() === typeof classCard.validTill
                          ? classCard.validTill
                          : classCard.validTill.toDate()
                      )}
                    >
                      <DatePicker
                        disabled={saving}
                        allowClear={false}
                        value={moment(
                          typeof String() === typeof classCard.validTill
                            ? classCard.validTill
                            : classCard.validTill.toDate()
                        )}
                        onChange={(val) =>
                          editClassCardHandle(
                            classCardId,
                            "validTill",
                            val.format("YYYY MM DD")
                          )
                        }
                      />
                    </Form.Item>
                  </Form>
                </Descriptions.Item>
                <Descriptions.Item span={3} label="Categories">
                  <Select
                    disabled={saving}
                    style={{ width: 300 }}
                    placeholder={"Select Categories"}
                    mode="multiple"
                    allowClear={false}
                    value={categories}
                    onChange={(val) => {
                      editClassCardHandle(classCardId, "categories", val);
                    }}
                  >
                    {class_card_categories.map((item) => {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Descriptions.Item>
              </Descriptions>
            </Card>
          </Col>
        </Row>
      </Layout>
    );
  } else {
    return (
      <Layout>
        <PageHeader
          onBack={() => window.history.back()}
          ghost={false}
          title="Edit class card"
          className="site-page-header"
        ></PageHeader>
        <Row>
          <Col sm={{ span: 24 }} md={{ span: 24 }} justify="center">
            <Card
              title="Class card is loading..."
              style={{ margin: "1rem 1rem 0 1rem" }}
              extra={<Skeleton.Button active />}
            >
              <Skeleton active />
            </Card>
          </Col>
        </Row>
      </Layout>
    );
  }
};

const mapStateToProps = (state, routeProps) => {
  return {
    classCard: state.firestore.data.selected_class_card ?? [],
    loaded: isLoaded(
      state.firestore.data.selected_class_card,
      state.firestore.ordered.class_card_categories
    ),
    error: state.onlineClass.error,
    classCardId: routeProps.match.params.classCardId,
    role: state.firebase.profile.token.claims.role,
    teacherUid: routeProps.userTeacherUid,
    class_card_categories: state.firestore.ordered.class_card_categories,
  };
};

const mapDispatchToProps = (dispatch, routeProps) => {
  return {
    editClassCard: (classCardId, key, value) =>
      dispatch(editClassCard(classCardId, key, value)),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((routeProps) => {
    let out = [
      {
        collection: "class_cards",
        doc: routeProps.match.params.classCardId,
        storeAs: "selected_class_card",
      },
    ];

    if (routeProps.classCard.teacherUid) {
      out.push({
        collection: "class_card_categories",
        where: [["teacherUid", "==", routeProps.classCard.teacherUid]],
      });
    }
    return out;
  })
)(SinglePostPage);
